import { Edge, Node } from '@xyflow/react';

import {
  initialBinaryConditionalNode,
  initialGroupsManageContactNode,
  initialHttpRequestNode,
  initialSendEmailNode,
  initialSendSMSNode,
  initialTagsManageContactNode,
  initialUpsertContactNode,
  NODE_TYPES_MAP,
} from '@/src/modules/AutomationModuleNew/constants/flows';
import {
  JourneyConnectionType,
  JourneyNodeTypes,
} from '@/src/modules/AutomationModuleNew/types/flowsTypes';

const getNumberId = (items: { id: string }[]) => {
  const existingIds = new Set(
    items
      .map((n) => {
        const match = n.id.match(/\d+/);
        return match ? parseInt(match[0], 10) : NaN;
      })
      .filter(Number.isFinite)
  );

  let counter = 1;
  while (existingIds.has(counter)) {
    counter++;
  }

  return counter;
};

export const getNextNodeId = (existingNodes: Node[]): string => {
  const nextId = getNumberId(existingNodes);
  return `node${nextId}`;
};

export const getNextEdgeId = (existingEdges: Edge[]): string => {
  const nextId = getNumberId(existingEdges);
  return `connection${nextId}`;
};

export const getMainNodeType = (type: JourneyNodeTypes) => {
  for (const [nodeType, types] of Object.entries(NODE_TYPES_MAP)) {
    if (types.includes(type)) return nodeType;
  }
  return 'default';
};

export const findRootNodeId = (
  nodes: Node[],
  connections: JourneyConnectionType[]
): string | null => {
  const nodesWithIncomingConnections = new Set(connections.map((c) => c.to));

  const rootNode = nodes.find((node) => !nodesWithIncomingConnections.has(node.id));

  return rootNode?.id || null;
};

export const getInitialNodeData = (type: JourneyNodeTypes) => {
  switch (type) {
    case 'upsertContact':
      return initialUpsertContactNode;
    case 'groupsManageContact':
      return initialGroupsManageContactNode;
    case 'sendEmail':
      return initialSendEmailNode;
    case 'binaryConditional':
      return initialBinaryConditionalNode;
    case 'sendSMS':
      return initialSendSMSNode;
    case 'tagsManageContact':
      return initialTagsManageContactNode;
    case 'httpRequest':
      return initialHttpRequestNode;
    default:
      return null;
  }
};
